import React from "react";
import ReactDOM from "react-dom";
import "./ErrorModal.css";

const ErrorModal = ({ isOpen, message, onClose, colorMain = "var(--color-main)", cancelText }) => {
    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        if (isOpen) {
            setShow(true);
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => { document.body.style.overflow = ""; };
    }, [isOpen]);

    React.useEffect(() => {
        const handleEsc = (e) => { if(e.key === "Escape") onClose(); };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [onClose]);

    if (!isOpen && !show) return null;

    const handleClose = () => { setShow(false); setTimeout(onClose, 250); };

    return ReactDOM.createPortal(
        <div
            className={`errorModalOverlay ${isOpen ? "fadeIn" : "fadeOut"}`}
            onClick={(e) => { if(e.target === e.currentTarget) handleClose(); }}
        >
            <div 
                className={`errorModalContainer ${isOpen ? "popIn" : "popOut"}`} 
                style={{ "--modal-color": colorMain }}
            >
                <button className="errorModalClose" onClick={handleClose}>x</button>
                <div className="errorModalIconWrapper">
                    <div className="errorModalIcon">
                        <svg viewBox="0 0 24 24" fill="#fff" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 
                                     2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 
                                     0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                </div>
                <p className="errorModalMessage">{message}</p>
                <div className="errorModalActions">
                    <button className="errorModalButton" onClick={handleClose}>
                        {cancelText || "Cerrar"}   
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ErrorModal;
